<template>
    <v-card>
        <v-card-title>
            {{ $t('site_setting') }} {{ webinar.title }}
        </v-card-title>
        <v-card-text>
            <v-form ref="seetingForm">
                <v-row>
                    <!-- <v-col cols="12" md="4">
                                <v-text-field v-model="setting.label"
                                    :label="$t('webinar_plus_site_label')"
                                    >
                                </v-text-field>
                            </v-col> -->
                    <v-col cols="12" md="4">
                        <v-text-field v-model="setting.title" :label="$t('webinar_plus_browser_title')">
                        </v-text-field>
                    </v-col> 
                    <v-col cols="12" md="4">
                        <v-text-field v-model="setting.message" :label="$t('webinar_plus_site_label')">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="setting.phone" :label="$t('webinar_plus_phone')"
                            class="text-content-left">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="setting.email" :label="$t('webinar_plus_email')"
                            class="text-content-left">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="setting.guide" :label="$t('webinar_plus_help_link')"
                            class="text-content-left">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-select v-model="setting.default1" :items="lang"
                            :label="$t('webinar_plus_default_language_1')">
                        </v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-select v-model="setting.default2" :items="lang"
                            :label="$t('webinar_plus_default_language_2')">
                        </v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-switch v-model="setting.has_ticket" :label="$t('webinar_plus_has_ticket')">
                        </v-switch>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="setting.ticket_url" :label="$t('webinar_plus_ticket_url')"
                            :disabled="!(setting.IsWebinarPlusActive && setting.WebinarPlusHasTicket)">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-switch v-model="setting.copyrightIsEnable" :label="$t('webinar_plus_enable_copy_right')">
                        </v-switch>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-switch v-model="setting.has_bpag" :label="$t('webinar_plus_has_bpag')">
                        </v-switch>
                    </v-col><v-col cols="12" md="4">
                        <v-switch v-model="setting.has_sell" :label="$t('webinar_plus_has_sell')">
                        </v-switch>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="setting.sms_url" :label="$t('webinar_plus_sms_url')">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-select :items="smsTokens" v-model="setting.sms_token" @keydown.enter="filterSMSLogs()"
                            :label="$t('webinar_plus_sms_token')" hide-details clearable>
                        </v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-select :items="gateways" v-model="setting.gateways" multiple chips :label="$t('gateways')"
                            hide-details clearable>
                        </v-select>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-file-input v-model="setting.logo" :label="$t('webinar_plus_logo')" class="text-content-left"
                            accept=".png">
                        </v-file-input>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-file-input v-model="setting.logo_brand" :label="$t('webinar_plus_logo_dark')"
                            class="text-content-left" accept=".png">
                        </v-file-input>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-file-input v-model="setting.logo_brand_dark" :label="$t('webinar_plus_toolbar_logo')"
                            class="text-content-left" accept=".png">
                        </v-file-input>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-file-input v-model="setting.favicon" :label="$t('webinar_plus_fav_icon')"
                            class="text-content-left" accept=".ico">
                        </v-file-input>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-switch v-model="setting.has_landing_page" :label="$t('has_landing_page')">
                        </v-switch>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn :color="setting.primary_color" dark v-on="on" block class='w-100 py-5'>
                                    {{ $t('primary_color') }}
                                </v-btn>
                            </template>
                            <v-color-picker v-model='setting.primary_color' dot-size="25" hide-inputs hide-mode-switch
                                swatches-max-height="200" value="#7417BE"></v-color-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn :color="setting.secondary_color" dark v-on="on" block class='w-100 py-5'>
                                    {{ $t('secondary_color') }}
                                </v-btn>
                            </template>
                            <v-color-picker v-model='setting.secondary_color' dot-size="25" hide-inputs hide-mode-switch
                                swatches-max-height="200" value="#7417BE"></v-color-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn :color="setting.tertiary_color" dark v-on="on" block class='w-100 py-5'>
                                    {{ $t('tertiary_color') }}
                                </v-btn>
                            </template>
                            <v-color-picker v-model='setting.tertiary_color' dot-size="25" hide-inputs hide-mode-switch
                                swatches-max-height="200" value="#7417BE"></v-color-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn :color="setting.quaternary_color" dark v-on="on" block class='w-100 py-5'>
                                    {{ $t('quaternary_color') }}
                                </v-btn>
                            </template>
                            <v-color-picker v-model='setting.quaternary_color' dot-size="25" hide-inputs
                                hide-mode-switch swatches-max-height="200" value="#7417BE"></v-color-picker>
                        </v-menu>
                    </v-col>

                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn text color="green darken-2" @click="saveAskDialog = true">
                {{ $t('save') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="close">
                {{ $t('close') }}
            </v-btn>
        </v-card-actions>
        <v-dialog v-model="saveAskDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <v-icon large right color="red"> mdi-comment-question-outline</v-icon>
                </v-card-title>
                <v-card-text>
                    {{ $t('webinar_setting_ask') }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="setSetting">{{ $t('yes') }}</v-btn>
                    <v-btn color="primary" text @click="saveAskDialog = false">{{ $t('no') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import axios from 'axios'
export default {
    name: 'WebinarSetting',
    props: ['webinar'],
    data() {
        return {
            setting: {
                'phone': '',
                'email': '',
                'copyrightIsEnable': false,
                'guide': '',
                'message': '',
                'title': '',
                'default1': 'fa',
                'default2': 'fa',
                'custom_script': '',
                'quaternary_color': '#3F863F',
                'tertiary_color': '#4F9EFF',
                'secondary_color': '#EFAE0E',
                'primary_color': '#002A86',
                'has_ticket': false,
                'ticket_url': '',
                'has_bpag': false,
                'has_sell': false,
                'sms_url': '',
                'sms_token': '',
                'gateways': '',
                'has_landing_page': false,
                'logo': '',
                'logo_brand': '',
                'logo_brand_dark': '',
                'favicon': ''
            },
            webinarPlusTokenFieldType: "password",
            saveDialog: false,
            webinarplusLoading: false,
            lang: [
                { text: this.$t('persian'), value: 'fa' },
                { text: this.$t('english'), value: 'en' },
                { text: this.$t('arabic'), value: 'ar' },
                { text: this.$t('turkey'), value: 'tr' }
            ],
            gateways: [
                { text: this.$t('gateway_mellat'), value: 'mellat' },
                { text: this.$t('gateway_pasargad'), value: 'pasargad' },
                { text: this.$t('gateway_zarinpal'), value: 'zarinpal' }
            ],
            tabs: 0,
            smsTokens: [],
            saveLoading: false,
            deleteLoading: false,
            saveAskDialog: false,
        }
    },
    watch: {
        webinar: {
            handler() {
                this.getSetting();
            },
            deep: true
        }
    },
    methods: {

        getSetting() {
            axios({
                url: process.env.VUE_APP_BACKEND_URL + "/api/webinar_plus/companies/" + this.webinar.id + "/setting",
                method: "GET",
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                    Authorization: this.$store.get("login/token"),
                },
            }).then(response => {
                console.log(response.data)
                this.setting = Object.assign({}, response.data);
                this.setting.copyrightIsEnable = (response?.data?.copyrightIsEnable == "1" ? true : false);
                this.setting.has_bpag = (response?.data?.has_bpag == 1 ? true : false);
                this.setting.has_landing_page = (response?.data?.has_landing_page == 1 ? true : false);
                this.setting.has_sell = (response?.data?.has_sell == 1 ? true : false);
                this.setting.has_ticket = (response?.data?.has_ticket == 1 ? true : false);
            }).catch(error => {
                console.log(error.response);
                this.$toasted.error(this.$t("no_setting"));
            });
        },
        setSetting() {
            console.log(this.setting)
            let payload = { company_id: this.webinar.id, ...this.setting };
            axios({
                url: process.env.VUE_APP_BACKEND_URL + "/api/webinar_plus/companies/" + this.webinar.id + "/setting",
                method: "POST",
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: this.$store.get("login/token"),
                },
                data: payload,
            }).then(() => {
                this.$toasted.success(this.$t("setting_save_successfully"));
                this.close()

            }).catch(error => {
                console.log(error.response);
                this.$toasted.error(this.$t("setting_saving_error"));
            });
        },
        close() {
            // this.setting = Object.assign({}, this.serverDefaultItem);
            //this.selectedServer={bigbluebutton_secret:'',bigbluebutton_url:''}
            this.$emit('close');
        }
    },
    mounted() {
        this.getSetting();
    },



}
</script>
<style>
.left-input input {
    text-align: left;
    direction: ltr;
}
</style>